/* @flow */
import cx from 'classnames';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Image from 'components/Image.jsx';
import MediaObject from 'components/MediaObject.jsx';
import React from 'react';

import './styles/DeliveryModalListItem.scss';

class DeliveryModalListItem extends React.Component {
  static propTypes = {
    image: React.PropTypes.string,
    text: React.PropTypes.string,
    info: React.PropTypes.object,
    avatar: React.PropTypes.object,
  };

  render() {
    return (
      <li className={cx('DeliveryModalListItem', this.props.className)}>
        <FlexibleBlock flex="left">
          <div>
            <MediaObject center gutter="small">
              <div>
                {this.props.image &&
                  <Image className="DeliveryModalListItem-image" src={this.props.image} />
                }
                {this.props.avatar}
              </div>
              {this.props.text}
            </MediaObject>
          </div>
          <div className="DeliveryModalListItem-info">
            {this.props.info}
          </div>
        </FlexibleBlock>
      </li>
    );
  }
}

export default DeliveryModalListItem;



// WEBPACK FOOTER //
// ./src/chat/components/DeliveryModalListItem.jsx